import moment from 'moment';
import translate from './components.language';

class HealthcarebookComponentsController {
    $onInit() {
        this.translate = translate;
        this.selectedLanguage = localStorage.getItem('languaje') || "en";
        this.languages = [{
            id: "any",
            name: "All languages"
        }, {
            "id": "en",
            "name": "English"
        },
            {
                "id": "es",
                "name": "Español"
            },
            {
                "id": "ko",
                "name": "Kreyòl ayisyen"
            }];
        this.data = {
            doctor: {
                name: 'Dr. Ivan Marshall, MD ',
                synthesis: `Lorem ipsum dolor sit amet consectetur adipisicing elit. 
                                    Quisquam voluptatem vitae quasi, corporis reiciendis labore 
                                    aperiam illo unde temporibus perspiciatis`,
                address: '4062 timber wolf trail',
                stars: 5,
                profession: 'Internist',
                image: 'https://randomuser.me/api/portraits/men/30.jpg',
                gender: 1,
                zip: "19083",
            },
            isSponsored: true,
            carriers: [{
                "id": 324,
                "name": "Anthem Blue Cross Blue Shield",
                "rank": 10213.440206576
            }, {
                "id": 550,
                "name": "Anthem Blue Cross",
                "rank": 3450.7950975920003
            },],
            horary: this.returnHoray(),
            firstDay: moment(new Date(new Date().setDate(new Date().getDate() + 0))).format('YYYY-MM-DD'),
            secondDay: moment(new Date(new Date().setDate(new Date().getDate() + 1))).format('YYYY-MM-DD'),
            thirdDay: moment(new Date(new Date().setDate(new Date().getDate() + 2))).format('YYYY-MM-DD'),
            distance: 5,
            timeBeforeOption: true,
            timeAfterOption: true,
            childrenOption: false,
            majorAvailableDate: this.returnDate(15, 30),
            languages: [{
                id: 1,
                name: 'Español'
            },
                {
                    id: 2,
                    name: 'English'
                },
                {
                    id: 3,
                    name: 'Russky'
                }
            ],
            procedures: [{
                id: 1,
                name: "General Consultation"
            },
                {
                    id: 2,
                    name: "General Follow Up"
                },
                {
                    id: 3,
                    name: "Anke Problems"
                },
                {
                    id: 4,
                    name: "Annual Check Up"
                },
                {
                    id: 5,
                    name: "Annual Physical"
                }
            ],
            address: [{
                "id": 1,
                "zip": "19401",
                "latitude": "89.56525358",
                "longitude": "-75.6523689",
                "country": "Spain",
                "streetAddress": "Ave. aa % 1 y 3"
            }]

        };
    }

    returnHoray() {
        const dates = [
            new Date(new Date().setDate(new Date().getDate() + 0)),
            new Date(new Date().setDate(new Date().getDate() + 1)),
            new Date(new Date().setDate(new Date().getDate() + 2)),
            new Date(new Date().setDate(new Date().getDate() + 3)),
            new Date(new Date().setDate(new Date().getDate() + 4)),
            new Date(new Date().setDate(new Date().getDate() + 5)),
            new Date(new Date().setDate(new Date().getDate() + 6)),
        ];
        let horary = {};

        dates.forEach(element => {
            let arrayDate = [];
            arrayDate.push(this.returnDate(Math.floor(Math.random() * 24), Math.floor(Math.random() * 60)));
            arrayDate.push(this.returnDate(Math.floor(Math.random() * 24), Math.floor(Math.random() * 60)));
            arrayDate.push(this.returnDate(Math.floor(Math.random() * 24), Math.floor(Math.random() * 60)));
            arrayDate.push(this.returnDate(Math.floor(Math.random() * 24), Math.floor(Math.random() * 60)));
            arrayDate.push(this.returnDate(Math.floor(Math.random() * 24), Math.floor(Math.random() * 60)));
            arrayDate.push(this.returnDate(Math.floor(Math.random() * 24), Math.floor(Math.random() * 60)));
            horary[moment(element).format('YYYY-MM-DD')] = arrayDate;
        });

        return horary;
    }

    returnDate(hours, minutes) {
        let date = new Date()
        date.setHours(hours)
        date.setMinutes(minutes);
        return date;
    }
}

export default HealthcarebookComponentsController;


//////////////////
// WEBPACK FOOTER
// ./src/health-care-book/components/components.controller.js
// module id = 624
// module chunks = 0